<template>
  
  <header id="app-header" dir="ltr" :class="headerClass">
    <div class="wrap-header flex items-center justify-between flex-wrap">
      <div class="flex flex-no-shrink items-center">
        <button
          v-if="showLogo === false" 
          class="text-gray-500 lg:hidden ml-3 block"
          @click="emit('sidebarToggle', true)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            role="img"
            width="2em"
            height="2em"
            preserveAspectRatio="xMidYMid meet"
            viewBox="0 0 16 16"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              d="M2.75 12.25h10.5m-10.5-4h10.5m-10.5-4h10.5"
            />
          </svg>
        </button>
        <img
          v-if="showHeaderLogo === true"
          :src="headerLogoURL"
          alt="Logo"
          class="h-7 w-auto mr-2 ml-2"
        />
        <router-link v-if="showLogo === true" to="/" exact class="flex flex-center ml-4" style="align-items: center;">
         
          <img
            v-if="globalState.whitelabel?.logoUrl !== undefined && globalState.whitelabel?.logoUrl !== null && globalState.whitelabel?.logoUrl !== ''"
            :src="globalState.whitelabel?.logoUrl"
            alt="Logo"
            class="h-7 w-auto mr-2"
          />
          <svg 
            v-else 
            xmlns="http://www.w3.org/2000/svg" 
            class="h-7 w-7 text-indigo-600 mr-2" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path>
          </svg>
          
        </router-link>
      
        <div
          class="input-box border dark:bg-gray-900 lg:ml-0 ml-5 dark:border-gray-700 rounded-md hidden lg:w-search w-full box-border lg:flex md:flex focus-within:bg-gray-100 dark:focus-within:bg-gray-700"
        style="display:none;">
          <span class="text-3xl p-2 text-gray-400"
            ><Icon icon="ei:search"
          /></span>
          <input
            type="text"
            :placeholder="t('header.searchPlaceholder', 'Search...')" 
            class="p-3 w-full bg-white dark:bg-gray-900 dark:text-gray-400 rounded-md outline-none focus:bg-gray-100 dark:focus:bg-gray-700"
          />
        </div>
      </div>

      <div class="mr-5 flex items-center">

        <div class="adi-header-chat-group mr-5 hidden" :dir="isRTL === true ? 'rtl' : 'ltr'">
          <button
            @click="openAdiWidget"
            type="button"
            class="adi-chat-trigger"
            :class="{ 'adi-chat-trigger-active': adiWidgetOpen === true }"
          >
            <span class="adi-chat-trigger-icon">
              <Icon icon="mingcute:ai-fill" class="adi-chat-trigger-icon-svg" />
            </span>
            <span class="adi-chat-trigger-label">{{ t('adi.chatWithAdi', 'Chat with AI') }}</span>
          </button>
          <button
            @click="openAdiFullscreen"
            type="button"
            class="adi-chat-expand-btn"
            :class="{ 'adi-chat-expand-btn-active': isAdiFullscreenRoute === true }"
            :title="t('adi.openFullscreen', 'Open full chat')"
            :aria-label="t('adi.openFullscreen', 'Open full chat')"
          >
            <Icon icon="ic:outline-fullscreen" class="w-4 h-4" />
          </button>
        </div>
       
        <button 
          v-if="showLogo === true" 
          @click="router.push('/')"
          class="btn btn-ghost text-sm normal-case mr-5"
          data-translate="sidebar.dashboard"
        >
          Dashboard
        </button>
        
        <button class="lg:hidden block mr-5 text-2xl text-gray-500 relative">
          <i>
            <Icon icon="ic:outline-search" />
          </i>
        </button>

        <button
          @click="fullscreenToggle"
          class="mr-5 text-2xl text-gray-500 relative"
        >
          <i v-if="fullscreenMode === false">
            <Icon icon="ic:outline-fullscreen" />
          </i>
          <i v-else>
            <Icon icon="ic:outline-fullscreen-exit" />
          </i>
        </button>

        <router-link
          to="/helpAgent"
          
          class="mr-5 text-2xl text-gray-500 relative"
        >
          <Icon icon="tabler:help-circle" />
        </router-link>

        <button
          @click="setTheme(true)"
          class="mr-5 text-2xl text-gray-500 hidden"
          v-if="darkMode === false"
        >
          <Icon icon="ph:sun-dim" />
        </button>
        <button
          @click="setTheme(false)"
          v-else
          class="mr-5 text-2xl text-gray-500"
        >
          <Icon icon="ri:moon-fill" />
        </button>
        
        <button
          @click="notifToggle"
          @blur="notifToggleBlur" 
          class="mr-5 text-2xl text-gray-500 relative"
        >
          <i
            class="bg-red-500 rounded-full p-1.5 border border-white dark:border-gray-700 -mt-1 absolute hidden"
          ></i>
          <Icon icon="clarity:notification-line" />
        </button>

        <transition name="fade">
          <div
            id="notificaitons"
            v-show="notification !== undefined && notification !== null && notification === true"
            class="block absolute lg:right-56 right-28 mt-12 z-50 w-96 border dark:border-gray-700 bg-white dark:bg-gray-800 rounded divide-y dark:divide-gray-700 divide-gray-100 shadow"
          >
           
            <div
              class="flex justify-between p-3 text-gray-800 dark:text-gray-300"
            >
              <h2 data-translate="header.notifications">Notifications</h2>
              <button class="text-blue-500 text-sm" data-translate="header.markAllAsRead">Mark all as Read</button>
            </div>
            <div
              class="p-5 text-center"
              v-if="notifList.length === 0"
            >
              <p class="text-gray-800 dark:text-gray-300" data-translate="header.noNotifications">
                No notifications yet.
              </p>
            </div>
            <div
              class="p-2 pl-3 w-full"
              v-for="(item, index) in notifList"
              :key="index"
            >
              <div class="flex">
                <div class="mr-5">
                  <img
                    class="w-9 rounded-full"
                    :src="imageAssets(item.image)" 
                    alt="Notification image"
                  />
                </div>
                <div class="mt-1">
                  <div class="flex">
                    <h2 class="dark:text-gray-200 mr-3">{{ item.name }}</h2>
                    <p class="dark:text-gray-500 text-gray-400 text-xs">
                      {{ limitText(item.message) }}
                    </p>
                  </div>
                  <p class="text-sm dark:text-gray-500 text-gray-400">
                    {{ item.hours }}
                  </p>
                </div>
              </div>
            </div>
            <div class="p-2">
              <button class="w-full p-2 text-gray-800 dark:text-gray-300" data-translate="header.viewAll">
                View All
              </button>
            </div>
          </div>
        </transition>

        <div class="relative ml-6">
        <button
          @blur="menuToggleBlur"
          @click="menuToggle"
        >
          <div class="user-avatar flex p-1 cursor-pointer" :class="{ 'flex-row-reverse': isRTL === true }" :dir="isRTL === true ? 'rtl' : 'ltr'">
            <div>
              <img v-if="isRTL === false"
                src="../assets/user-alt-1-svgrepo-com.svg" 
                class="mr-4 w-10 h-10 p-1 ring-1 ring-gray-300 dark:ring-gray-500 p-2 mask mask-squircle"
                alt="User Avatar"
                style="background-color: rgb(244 244 244);"
              />
            </div>
            <div :class="['lg:block md:block hidden', isRTL === true ? 'text-right' : 'text-left']" :dir="isRTL === true ? 'rtl' : 'ltr'">
              <h2 id="user-greeting" class="dark:text-white text-gray-800">
                {{ t('greeting', 'Hello') }}, {{ userName }}
              </h2>
              <p class="text-xs text-gray-400 dark:text-gray-500">
                {{ userOrganization }}
              </p>
            </div>
            <img v-if="isRTL === true"
                src="../assets/user-alt-1-svgrepo-com.svg" 
                class="ml-4 w-10 h-10 p-1 ring-1 ring-gray-300 dark:ring-gray-500 p-2 mask mask-squircle"
                alt="User Avatar"
                style="background-color: rgb(244 244 244);"
              />
          </div>
        </button>

        <transition name="fade">
          <div
            id="dropdownSmall"
            v-show="menu === true"
                :class="['absolute top-full mt-2 z-50 border dark:border-gray-700 bg-white dark:bg-gray-800 rounded divide-y dark:divide-gray-700 divide-gray-100 shadow', isRTL === true ? 'left-0' : 'right-0']"
                style="width: 180px;"
          >
            <div class="hidden py-3 px-4 text-sm text-gray-900 dark:text-gray-200">
              <div data-translate="header.loggedAs">Logged As</div>
              <div class="font-medium truncate">{{ userName }}</div> 
            </div>
            <ul
              class="py-1 hidden text-sm text-gray-700 dark:text-gray-200"
              aria-labelledby="dropdownSmallButton"
            >
              <li class="hidden">
                <a
                  href="#"
                  class="block py-2 px-4 hover:bg-primary hover:text-white"
                  data-translate="header.userProfile"
                  >User Profile</a 
                >
              </li>
              <li class="hidden">
                <a
                  href="#"
                  class="block py-2 px-4 hover:bg-primary hover:text-white"
                  data-translate="header.settings"
                  >Settings</a 
                >
              </li>
            </ul>

            <div class="py-1">
              <a
                href="#"
                @click.prevent="openLanguageModal"
                class="block py-2 px-4 text-sm text-gray-700 dark:text-gray-200 hover:bg-primary hover:text-white"
                data-translate="header.changeLanguage"
                >Change Language</a 
              >
            </div>

            <div class="py-1">
              <a
                href="#" 
                @click.prevent="logout" 
                class="block py-2 px-4 text-sm text-gray-700 dark:text-gray-200 hover:bg-primary hover:text-white"
                data-translate="header.signOut"
                >Sign out</a 
              >
            </div>
          </div>
        </transition>
        </div>
      </div>
    </div>
  </header>

  <teleport to="body">
    <div v-if="isLanguageModalOpen === true" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" @click.self="closeLanguageModal">
      <div class="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl w-full max-w-md mx-auto">
        <h3 class="text-lg font-medium leading-6 text-gray-900 dark:text-gray-100 mb-4" data-translate="header.selectLanguage">Select Language</h3>
        
        <div class="mt-2">
          <button 
            v-for="lang in availableLanguages"
            :key="lang.code"
            @click="selectLanguage(lang.code)"
            class="mb-2"
            :class="[
              'w-full text-left px-4 py-2 rounded-md text-sm font-medium',
              lang.code === currentLanguage ? 'bg-primary text-white' : 'text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700'
            ]"
          >
            {{ lang.name }} 
          </button>
        </div>

        <div class="mt-6 flex justify-end">
          <button @click="closeLanguageModal" type="button" class="btn btn-ghost" data-translate="header.cancel">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </teleport>
  <HelpAgentWidget v-if="helpAgentOpen === true" @close="helpAgentOpen = false" />
  <TermsAndConditionsModal v-if="showTermsModal === true" @close="showTermsModal = false"/>
  <PrivacyPolicyModal v-if="showPrivacyModal === true" @close="showPrivacyModal = false"/>
</template>

<style scoped>
.header-modern {
  background-color: #ffffff;
  border-bottom: 1px solid #f1f5f9;
  padding: 0.75rem 1.5rem;
  position: sticky;
  top: 0;
  z-index: 50;
  height: 64px;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.dark .header-modern {
  background-color: #0f172a;
  border-bottom-color: #1e293b;
}

.header-modern .wrap-header {
  width: 100%;
  max-width: 100%;
}

.header-modern .btn-ghost {
  background-color: transparent;
  border: 1px solid transparent;
  color: #64748b;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.header-modern .btn-ghost:hover {
  background-color: #f8fafc;
  color: #0f172a;
  border-color: #e2e8f0;
}

.dark .header-modern .btn-ghost {
  color: #94a3b8;
}

.dark .header-modern .btn-ghost:hover {
  background-color: #1e293b;
  color: #f8fafc;
  border-color: #334155;
}

.header-modern .text-gray-500, 
.header-modern .text-2xl {
  color: #94a3b8;
  transition: color 0.2s ease;
}

.header-modern button:hover .iconify,
.header-modern a:hover .iconify {
  color: #0f172a;
}

.dark .header-modern button:hover .iconify,
.dark .header-modern a:hover .iconify {
  color: #f8fafc;
}

.header-modern .user-avatar {
  background-color: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 100px;
  padding: 0.25rem 0.75rem 0.25rem 0.25rem;
  transition: all 0.2s ease;
}

.header-modern .user-avatar:hover {
  background-color: #ffffff;
  border-color: #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.dark .header-modern .user-avatar {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .header-modern .user-avatar:hover {
  background-color: #0f172a;
  border-color: #475569;
}

.header-modern #user-greeting {
  font-weight: 600;
  color: #0f172a;
  margin-bottom: -2px;
}

.dark .header-modern #user-greeting {
  color: #f8fafc;
}

.header-modern .mask-squircle {
  mask-image: none;
  border-radius: 9999px;
  background-color: #f1f5f9 !important;
}

.adi-header-chat-group {
  display: flex;
  align-items: stretch;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.dark .adi-header-chat-group {
  border-color: #334155;
  background-color: #0f172a;
}

.adi-chat-trigger {
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  color: #0f172a;
  padding: 0.3rem 0.8rem 0.3rem 0.3rem;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.adi-chat-trigger:hover {
  background-color: #f8fafc;
}

.adi-chat-trigger-active {
  background-color: #f1f5f9;
}

.dark .adi-chat-trigger {
  color: #f8fafc;
}

.dark .adi-chat-trigger:hover,
.dark .adi-chat-trigger-active {
  background-color: #1e293b;
}

.adi-chat-trigger-icon {
  width: 1.85rem;
  height: 1.85rem;
  border-radius: 9999px;
  background: linear-gradient(135deg, #dbeafe 0%, #f8fafc 100%);
  border: 1px solid #bfdbfe;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 0.5rem;
}

.dark .adi-chat-trigger-icon {
  background: linear-gradient(135deg, #1e3a8a 0%, #0f172a 100%);
  border-color: #334155;
}

.adi-chat-trigger-icon-svg {
  width: 1rem;
  height: 1rem;
  color: #2563eb;
}

.dark .adi-chat-trigger-icon-svg {
  color: #93c5fd;
}

.adi-chat-trigger-label {
  white-space: nowrap;
}

.adi-chat-expand-btn {
  width: 2.4rem;
  border: none;
  border-left: 1px solid #e2e8f0;
  background-color: transparent;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.adi-chat-expand-btn:hover {
  background-color: #f8fafc;
  color: #0f172a;
}

.dark .adi-chat-expand-btn {
  border-left-color: #334155;
  color: #94a3b8;
}

.dark .adi-chat-expand-btn:hover {
  background-color: #1e293b;
  color: #f8fafc;
}

.adi-chat-expand-btn-active {
  background-color: #eff6ff;
  color: #2563eb;
}

.dark .adi-chat-expand-btn-active {
  background-color: #172554;
  color: #93c5fd;
}

.adi-header-chat-group[dir='rtl'] .adi-chat-trigger {
  padding: 0.3rem 0.3rem 0.3rem 0.8rem;
}

.adi-header-chat-group[dir='rtl'] .adi-chat-trigger-icon {
  margin-right: 0;
  margin-left: 0.5rem;
}

.adi-header-chat-group[dir='rtl'] .adi-chat-expand-btn {
  border-left: none;
  border-right: 1px solid #e2e8f0;
}

.dark .adi-header-chat-group[dir='rtl'] .adi-chat-expand-btn {
  border-right-color: #334155;
}

.dark .header-modern .mask-squircle {
  background-color: #334155 !important;
}
</style>

<script setup>
import { ref, computed, onMounted, watch, nextTick, inject } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Icon } from "@iconify/vue/dist/offline";
import { fullscreen } from "@/helper/fullscreen";
import { setDarkMode, loadDarkMode } from "@/helper/theme";
import { globalState } from "@/globalState";
import { useToast } from "vue-toastification";
import { useI18n, applyTranslationsToDOM } from '@/i18n';
import HelpAgentWidget from '@/components/HelpAgentWidget.vue';
import TermsAndConditionsModal from '@/components/TermsAndConditionsModal.vue'
import PrivacyPolicyModal from '@/components/PrivacyPolicyModal.vue'
import { logoutSession } from '@/api/accountsService';
const headerClass = computed(() => {
  return 'bg-white dark:bg-gray-800 p-2 border-b-2 dark:border-gray-700';
});

const showTermsModal = ref(false)
const showPrivacyModal = ref(false)
const headerLogoURL = process.env.VUE_APP_HEADERLOGO_URL;

const showHeaderLogo = computed(
  () => headerLogoURL && headerLogoURL !== '__VUE_APP_HEADERLOGO_URL__'
);

const props = defineProps({
  showLogo: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['sidebarToggle']);

const menu = ref(false);
const darkMode = ref(false);
const notification = ref(false);
const fullscreenMode = ref(false);
const showDropdown = ref(false);
const notifList = ref([]);

const toast = useToast();
const router = useRouter();
const route = useRoute();

const isAdiFullscreenRoute = computed(() => {
  return route.path === '/chat' && route.query.adi === '1';
});

const { currentLanguage, availableLanguages, setCurrentLanguage, t } = useI18n();

const isRTL = computed(() => {
  const lang = availableLanguages.value.find(lang => lang.code === currentLanguage.value);
  return lang?.dir === 'rtl';
});

const userName = computed(() => {
    return globalState.userInfo?.userName !== undefined && globalState.userInfo?.userName !== null && globalState.userInfo?.userName !== '' ? globalState.userInfo?.userName : "User";
});
const userOrganization = computed(() => globalState.userInfo?.organizationName !== undefined && globalState.userInfo?.organizationName !== null && globalState.userInfo?.organizationName !== '' ? globalState.userInfo?.organizationName : '');

watch(route, () => {
  menu.value = false;
  notification.value = false;
});

const menuToggle = () => {
  menu.value = !menu.value;
};

const menuToggleBlur = () => {
  menu.value = false;
};

const notifToggle = () => {
  notification.value = !notification.value;
};

const notifToggleBlur = () => {
  notification.value = false;
};

const limitText = (message) => {
  const text =
    message.length > 25 ? message.substring(0, 25) + "..." : message;
  return text;
};

const fullscreenToggle = () => {
  fullscreenMode.value = !fullscreenMode.value;
  fullscreen(fullscreenMode.value);
};

const setTheme = (bool) => {
  darkMode.value = bool;
  setDarkMode(bool);
};

const imageAssets = (url) => {
  return new URL(`/src/assets/img/${url}`, import.meta.url).href;
};

const logout = async () => {
  try {
    await logoutSession();
  } catch (e) {}
  const sameSiteLax = (process.env.environment === 'production') ? '; SameSite=Lax' : '';
  document.cookie = `authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${sameSiteLax}`;
  document.cookie = `jwtToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${sameSiteLax}`;
  document.cookie = `userData=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${sameSiteLax}`;
  document.cookie = `orgSettings=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${sameSiteLax}`;
  globalState.userInfo = null;
  router.push('/login');
};

const toggleDropdown = () => {
  showDropdown.value = !showDropdown.value;
};

const isLanguageModalOpen = ref(false);

const openLanguageModal = () => {
  isLanguageModalOpen.value = true;
  menu.value = false; 
};

const closeLanguageModal = () => {
  isLanguageModalOpen.value = false;
};

const selectLanguage = async (langCode) => {
  await setCurrentLanguage(langCode); 
  closeLanguageModal();
  toast.success(t('header.languageChanged')); 
  location.reload();
};

const helpAgentOpen = ref(false);

const toggleHelpAgent = () => {
  helpAgentOpen.value = helpAgentOpen.value === false;
};

const toggleAdiWidget = inject('toggleAdiWidget', null);
const closeAdiWidget = inject('closeAdiWidget', null);
const adiWidgetOpen = inject('adiWidgetOpen', ref(false));

const openAdiWidget = () => {
  if (toggleAdiWidget !== null && typeof toggleAdiWidget === 'function') {
    toggleAdiWidget();
  }
};

const openAdiFullscreen = () => {
  if (adiWidgetOpen.value === true) {
    if (closeAdiWidget !== null && typeof closeAdiWidget === 'function') {
      closeAdiWidget();
    }
  }
  router.push({ path: '/chat', query: { adi: '1' } });
};

onMounted(async () => {
  darkMode.value = loadDarkMode();
  await nextTick();
  applyTranslationsToDOM(document.getElementById('app-header')); 

  document.onfullscreenchange = (event) => {
    if (document.fullscreenElement !== null) { 
      fullscreenMode.value = true;
    } else {
      fullscreenMode.value = false;
    }
  };
});


watch(currentLanguage, async (newLang, oldLang) => {
    if (newLang !== oldLang) {
        await nextTick();
        applyTranslationsToDOM(document.getElementById('app-header'));
    }
});

</script>
